import type { PropsWithChildren } from 'react';

import FeatureFlagsProviderContext, {
  type FeatureFlagsProviderContextProps,
} from '../providers/FeatureFlagsProviderContext';

/**
 * Test provider for feature-flag context. **`isUserContextIdentified`** defaults to **`ready`**
 * when omitted; pass both explicitly when a scenario needs them to differ (e.g. async-ready
 * but not yet identified), matching production semantics from **`FeatureFlagsResolver`**.
 */
const FeatureFlagsWrapper = ({
  ready = true,
  isUserContextIdentified: isUserContextIdentifiedProp,
  setContext = vi.fn(),
  children,
}: PropsWithChildren<
  Partial<FeatureFlagsProviderContextProps>
>): JSX.Element => {
  const isUserContextIdentified = isUserContextIdentifiedProp ?? ready;
  return (
    <FeatureFlagsProviderContext.Provider
      value={{ setContext, ready, isUserContextIdentified }}
    >
      {children}
    </FeatureFlagsProviderContext.Provider>
  );
};

export default FeatureFlagsWrapper;
